<template>
    <div
        class="reminder-banner"
        :class="{ 'is-revision': type === 'revision' }"
        v-if="showReminder"
        @click="gotoReminderPage"
        :style="{ 'background-image': `url(${pageImage})` }"
    ></div>
</template>

<script>
import * as api from 'root/topic/views/reminder/api/setting';
import util from 'root/blackcard/util/index.js';
import localStorageKey from 'root/common/const/localStorageKey';
import * as nativeApi from 'root/blackcard/nativeApi/index.js';

let appversion = window.navigator.userAgent.split('/')[2] || '1.12.0';
// TODO: onvisiblechange控制回退显示
const baseLink = '/new/topic/views/reminder/setting/setting.html';
const baseVersion = '1.21.0';
const timeRange = 5 * 60 * 1000;

export default {
    name: 'reminder-banner',
    props: {
        mark: {
            type: String,
            required: true,
        },
        showReminder: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            pageImage: '',
            link: '',
            reminderPageData: JSON.parse(window.localStorage.getItem(localStorageKey.reminderPageData) || '{}'),
            isApp: window.__is_blackApp,
        };
    },
    created() {
        this.handleShowReminder();
    },
    mounted() {
        // app对应版本触发
        if (this.isApp && util.versionCompare(appversion, baseVersion)) {
            nativeApi.onVisibilityChange(isShow => {
                if (isShow) {
                    this.handleShowReminder();
                }
            });
        }
    },
    watch: {
        showReminder(val) {
            if (val) {
                this.$emit('visible-reminder');
            }
        },
    },
    methods: {
        async handleShowReminder() {
            // '1.21.0' 以下不支持打开权限列表操作
            if (!this.isApp || !util.versionCompare(appversion, baseVersion)) {
                this.$emit('update:showReminder', false);
                return;
            }
            if (
                this.reminderPageData &&
                this.reminderPageData[this.mark] &&
                this.reminderPageData[this.mark].pageImage
            ) {
                const pageData = this.reminderPageData[this.mark];
                // 读取缓存
                // 更新时间五分钟
                const now = new Date().getTime();
                if (+pageData.lastUpdateTime + timeRange > now) {
                    this.reminderMark = pageData.reminderMark;
                    this.pageImage = pageData.pageImage;
                    this.link = `${baseLink}?reminderMark=${this.reminderMark || ''}`;
                    this.$emit('update:showReminder', true);
                    return;
                }
            }
            // 请求接口数据
            let isShow;
            try {
                await this.fetchPageImage();
                isShow = true;
            } catch (error) {
                console.log('error:', error);
                isShow = false;
            }
            this.$emit('update:showReminder', isShow);
        },
        saveCache(pageData) {
            // 更新时间五分钟
            if (pageData) {
                pageData.lastUpdateTime = new Date().getTime();
            }
            this.reminderPageData[this.mark] = pageData;
            window.localStorage.setItem(localStorageKey.reminderPageData, JSON.stringify(this.reminderPageData));
        },
        async fetchPageImage() {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (reslove, reject) => {
                try {
                    const result = await api.pageImage({ mark: this.mark });
                    if (+result.code === 0 && result.data) {
                        if (result.data.pageImage && result.data.reminderMark) {
                            this.pageImage = result.data.pageImage;
                            this.reminderMark = result.data.reminderMark;
                            this.link = `${baseLink}?reminderMark=${result.data.reminderMark || ''}`;
                            this.saveCache({
                                pageImage: result.data.pageImage,
                                reminderMark: result.data.reminderMark,
                            });
                            reslove();
                        } else {
                            reject();
                        }
                    } else {
                        this.$toast(result.msg);
                        reject();
                    }
                } catch (error) {
                    console.log('error:', error);
                    reject();
                }
            });
        },
        gotoReminderPage() {
            this.$emit('click-reminder');
            this.saveCache(null);
            window.location.href = this.link;
        },
    },
};
</script>

<style scoped lang="scss">
.reminder-banner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.8rem;
    background-size: cover;
    z-index: 100;
    background-repeat: no-repeat;
    background-position: center;
    background-origin: border-box;
    vertical-align: middle;
    background-size: contain;
    &.is-revision {
        position: absolute;
        top: calc(env(safe-area-inset-top) + 0.88rem);
        top: calc(constant(safe-area-inset-top) + 0.88rem);
    }
}
</style>
